import { Component, ViewChild } from '@angular/core';
import { CalendarMarkerData } from '../calender/calender.component';
import { SessionsService } from 'projects/app-core/src/app/session/service/sessions.service';
import { NzTabChangeEvent } from 'ng-zorro-antd/tabs';
import {
  SessionGridRequest,
  SessionGridTab,
} from 'projects/app-core/src/app/session/models/sessionGridRequest';
import {
  SessionGridResponse,
  SessionGridResponseData,
} from 'projects/app-core/src/app/session/models/sessionGridResponse';
import { AnyoSortDirection } from 'projects/app-core/src/models/gridRequest';
import * as moment from 'moment';
import { SessionTableComponent } from 'projects/app-core/src/app/session/components/session-table/session-table.component';
import { lastValueFrom } from 'rxjs';
import { ToastService } from 'projects/app-core/src/app/services/toastr.service';
import { AuthService } from 'projects/app-core/src/auth/auth.service';
import { UtilsService } from 'projects/app-core/src/service/utils.service';
import { IAnyoError } from 'projects/app-core/src/models/errorModal';

interface DropdownOptions {
  value: string;
  label: string;
}

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrl: './view.component.scss',
})
export class ViewComponent {
  markers: CalendarMarkerData<{
    therapistName: string;
    sessionTime: string;
    sessionDetails: SessionGridResponseData;
  }>[] = [
    // {
    //   date: addDays(new Date(), 1),
    //   data: {
    //     title: 'Netflix',
    //   },
    // },
    // {
    //   date: addDays(new Date(), 1),
    //   data: {
    //     title: 'Google One',
    //   },
    // },
    // {
    //   date: addDays(new Date(), 5),
    //   data: {
    //     title: 'Youtube Premium',
    //   },
    // },
  ];
  sessionTableQuery: SessionGridRequest | undefined;
  globalSearchInput: string = '';
  pageSize: number = 10;

  tabs = [SessionGridTab.NEW_APPOINTMENTS, SessionGridTab.ALL];
  @ViewChild('sessionTableComponent')
  sessionTableComponent?: SessionTableComponent;
  @ViewChild('allSessionTableComponent')
  allSessionTableComponent?: SessionTableComponent;
  selectedTab: number = 0;
  tableData: SessionGridResponse = {
    data: [],
    filterOptions: {
      partners: [],
      therapists: [],
      sessionStatus: [],
      partnerId: [],
    },
    pageNum: 1,
    pageSize: 10,
    totalPages: 0,
    totalRecords: 0,
  };
  dateRange: Date[] | undefined;
  tableSpinner = false;
  therapists: DropdownOptions[] = [];
  selectedTherapists: string[] = [];

  constructor(
    private sessionService: SessionsService,
    private toastService: ToastService,
    private auth: AuthService,
    public utils: UtilsService,
  ) {}

  async tabChange($event: NzTabChangeEvent) {
    this.selectedTab = $event.index!;
    this.dateRange = [
      moment().startOf('month').toDate(),
      moment().endOf('month').toDate(),
    ];
    this.tableData = {
      data: [],
      filterOptions: {
        partners: [],
        therapists: [],
        sessionStatus: [],
        partnerId: [],
      },
      pageNum: 1,
      pageSize: 10,
      totalPages: 0,
      totalRecords: 0,
    };
    this.globalSearchInput = '';
    if (!this.sessionTableQuery) {
      this.sessionTableQuery = {
        export: true,
        sort: undefined,
        filters: {
          SESSION_STATUS: [],
          THERAPIST_EMAIL: [],
          HIDE_TEST_BOOKING: ['true'],
          USER_ID: [],
          PARTNER_ID: [],
          SESSION_TAG: [],
        },
        globalSearch: [],
        page: 1,
        pageSize: this.pageSize,
        tab: this.tabs[this.selectedTab],
      };
    }
    if (this.dateRange && this.dateRange.length == 2) {
      this.sessionTableQuery!.from = Number(
        moment(this.dateRange[0]).format('x'),
      );
      this.sessionTableQuery!.to = Number(
        moment(this.dateRange[1]).format('x'),
      );
    }
    if (this.sessionTableComponent) {
      this.sessionTableComponent.resetValues();
    }
    if (this.allSessionTableComponent) {
      this.allSessionTableComponent.resetValues();
    }
    if ($event.index == 0) {
      this.sessionTableQuery!.tab = SessionGridTab.NEW_APPOINTMENTS;
    }
    if ($event.index == 1) {
      this.sessionTableQuery!.tab = SessionGridTab.ALL;
    }
    await this.listSession();
  }

  async listSession() {
    try {
      this.tableSpinner = true;
      if (this.sessionTableComponent) {
        this.sessionTableQuery!.filters!.HIDE_TEST_BOOKING = ['true'];
      }
      if (this.allSessionTableComponent) {
        this.sessionTableQuery!.filters!.HIDE_TEST_BOOKING = ['true'];
      }
      this.tableData = await lastValueFrom(
        this.sessionService.fetchSessions(this.sessionTableQuery!),
      );
      this.markers = this.tableData.data
        .map((data) => ({
          date: moment(data.sessionStart, 'x').toDate(),
          data: {
            therapistName: data.therapistDetails.therapistName,
            sessionTime: `${moment(data.sessionStart, 'x').format('hh:mm:A')} - ${moment(data.sessionEnd, 'x').format('hh:mm:A')}`,
            sessionDetails: data,
          },
        }))
        .sort((a, b) => {
          const timeA = moment(a.date).hours() * 60 + moment(a.date).minutes();
          const timeB = moment(b.date).hours() * 60 + moment(b.date).minutes();
          return timeA - timeB;
        });
      this.tableSpinner = false;
      this.therapists = this.tableData.filterOptions.therapists.map((data) => ({
        label: data.name,
        value: data.id,
      }));
      if (this.sessionTableComponent) {
        this.sessionTableComponent.setTherapistFilterData(
          this.tableData.filterOptions,
        );
        this.sessionTableComponent.setSessionStatusFilterData(
          this.tableData.filterOptions,
        );
        this.sessionTableComponent.setPartnerIdFilterData(
          this.tableData.filterOptions,
        );
        this.sessionTableComponent.setPartnerNameFilterData(
          this.tableData.filterOptions,
        );
        this.sessionTableComponent.setSessionTagFilterData(
          this.tableData.filterOptions,
        );
      }
      if (this.allSessionTableComponent) {
        this.allSessionTableComponent.setTherapistFilterData(
          this.tableData.filterOptions,
        );
        this.allSessionTableComponent.setSessionStatusFilterData(
          this.tableData.filterOptions,
        );
        this.allSessionTableComponent.setPartnerIdFilterData(
          this.tableData.filterOptions,
        );
        this.allSessionTableComponent.setPartnerNameFilterData(
          this.tableData.filterOptions,
        );
        this.allSessionTableComponent.setSessionTagFilterData(
          this.tableData.filterOptions,
        );
      }
    } catch (e: any) {
      this.tableSpinner = false;
      const errorMessage =
        e?.error?.description ?? e?.message ?? 'Something went wrong...';
      this.toastService.showAnyoErrorToast(errorMessage);
    }
  }

  async therapistFilterFn($event: string) {
    if (!this.sessionTableQuery!.filters) {
      this.sessionTableQuery!.filters = {
        SESSION_STATUS: [],
        THERAPIST_EMAIL: [],
        HIDE_TEST_BOOKING: [],
        USER_ID: [],
        PARTNER_ID: [],
        SESSION_TAG: [],
      };
    }
    if ($event && $event.length) {
      this.sessionTableQuery!.filters.THERAPIST_EMAIL = [$event];
    } else {
      this.sessionTableQuery!.filters.THERAPIST_EMAIL = [];
    }
    await this.listSession();
  }

  async resetFilter() {
    this.selectedTherapists = [];
    this.globalSearchInput = '';
    this.sessionTableQuery = {
      export: true,
      sort: {
        SESSION_DATE: AnyoSortDirection.DESC,
        THERAPIST_RATING: AnyoSortDirection.DESC,
      },
      filters: {
        THERAPIST_EMAIL: [],
        SESSION_STATUS: [],
        HIDE_TEST_BOOKING: ['true'],
        USER_ID: [],
        PARTNER_ID: [],
        SESSION_TAG: [],
      },
      globalSearch: [],
      page: 1,
      pageSize: this.pageSize,
      tab: this.tabs[this.selectedTab],
    };
    this.dateRange = [
      moment().startOf('month').toDate(),
      moment().endOf('month').toDate(),
    ];
    if (this.dateRange && this.dateRange.length == 2) {
      this.sessionTableQuery!.from = Number(
        moment(this.dateRange[0]).format('x'),
      );
      this.sessionTableQuery!.to = Number(
        moment(this.dateRange[1]).format('x'),
      );
    }
    if (this.sessionTableComponent) {
      this.sessionTableComponent!.resetValues();
    }
    if (this.allSessionTableComponent) {
      this.allSessionTableComponent!.resetValues();
    }
    await this.listSession();
  }

  filterByRange(date: Date) {
    this.dateRange = [
      moment(date).startOf('month').toDate(),
      moment(date).endOf('month').toDate(),
    ];
    if (this.dateRange && this.dateRange.length == 2) {
      this.sessionTableQuery!.from = Number(
        moment(this.dateRange[0]).format('x'),
      );
      this.sessionTableQuery!.to = Number(
        moment(this.dateRange[1]).format('x'),
      );
    }
    this.listSession();
  }

  ngOnInit() {
    this.auth.currentAuthStatus.subscribe((user: any) => {
      if (user) {
        this.dateRange = [
          moment().startOf('month').toDate(),
          moment().endOf('month').toDate(),
        ];
        this.sessionTableQuery = {
          sort: {
            SESSION_DATE: AnyoSortDirection.ASC,
            THERAPIST_RATING: undefined,
          },
          dateFilters: undefined,
          export: true,
          filters: {
            SESSION_STATUS: [],
            THERAPIST_EMAIL: [],
            USER_ID: [],
            PARTNER_ID: [],
            HIDE_TEST_BOOKING: ['true'],
            SESSION_TAG: [],
          },
          from: undefined,
          globalSearch: [],
          page: 1,
          pageSize: this.pageSize,
          searchQuery: undefined,
          tab: SessionGridTab.NEW_APPOINTMENTS,
          to: undefined,
        };
        if (this.dateRange && this.dateRange.length == 2) {
          this.sessionTableQuery!.from = Number(
            moment(this.dateRange[0]).format('x'),
          );
          this.sessionTableQuery!.to = Number(
            moment(this.dateRange[1]).format('x'),
          );
        }
        this.listSession();
      }
    });
  }

  isVisible = false;
  sessionData: SessionGridResponseData[] = [];
  sessionDetailTitle = '';

  showModal(data: SessionGridResponseData, title: string): void {
    this.sessionData = [];
    this.sessionDetailTitle = title;
    this.sessionData.push(data);
    this.isVisible = true;
  }

  handleOk(): void {
    this.isVisible = false;
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  formatSessionDate(date?: string | undefined) {
    if (!date) {
      return 'N/A';
    }
    return moment(date, 'x').format('DD/MM/yyyy');
  }

  formatSessionTime(date: string) {
    return moment(date, 'x').format('hh:mm A');
  }
}
